// Castintech dashboard — Canli (Live activity feed) view modulu.
// Faz 9b PR8 — sade view, son 30 task'i timeline tarzinda render eder.
// Faz 13 — strict TS hardening: @ts-nocheck kaldirildi, tip annotation eklendi.

import { state } from '../state.js';
import { ago, getGem, normStatus, statusLabel, $ } from '../utils.js';
import type { Agent, Issue } from '../../types/api';

type StatusKey = 'in_progress' | 'done' | 'blocked' | 'todo' | 'backlog';

// Faz 47.2 S3.B — Canlı view agent filtresi (audit "agent bazlı filtre olsa
// 'sadece Atlas hareketleri' görmek mümkün olurdu" bulgusunu kapatır).
let _canliAgentFilter: string = ''; // boş = tümü
function setCanliAgentFilter(agentId: string): void {
  _canliAgentFilter = agentId;
  renderCanli();
}
(window as unknown as Record<string, unknown>).canliSetAgentFilter = setCanliAgentFilter;

export function renderCanli(): void {
  const aMap: Record<string, Agent> = {};
  state.agents.forEach(a => { if (a.id) aMap[a.id] = a; });
  // Filtre uygulandıysa son 30 yerine son 60 task'tan filtrele (filtreden
  // sonra 30 görünür gelene kadar daha geniş havuz).
  const filtered = _canliAgentFilter
    ? state.tasks.filter(t => (t.assigneeAgentId || t.assignee_id) === _canliAgentFilter)
    : state.tasks;
  const recent: Issue[] = [...filtered]
    .sort((a, b) => new Date(b.updatedAt || b.created_at || 0).getTime() - new Date(a.updatedAt || a.created_at || 0).getTime())
    .slice(0, 30);

  const view = $('live-view');
  if (!view) return;

  // Filter dropdown — her render'da güncelle (state.agents değişebilir)
  const filterEl = $('canli-filter');
  if (filterEl) {
    const opts = ['<option value="">Tüm ajanlar</option>']
      .concat(state.agents
        .filter(a => a.id && a.name)
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        .map(a => `<option value="${a.id}" ${a.id === _canliAgentFilter ? 'selected' : ''}>${a.name}</option>`)
      ).join('');
    if (filterEl.innerHTML !== opts) filterEl.innerHTML = opts;
    (filterEl as unknown as HTMLSelectElement).onchange = (e: Event) => {
      setCanliAgentFilter((e.target as HTMLSelectElement).value);
    };
  }

  if (!recent.length) {
    const hint = _canliAgentFilter
      ? `Bu agent için son hareket yok. <a href="#" onclick="window.canliSetAgentFilter('');return false">Tümünü göster</a>`
      : 'Görevler oluşturulunca burada görünür';
    view.innerHTML = `<div class="empty-state"><div class="empty-icon">⚡</div><div class="empty-title">Henüz aktivite yok</div><div class="empty-sub">${hint}</div></div>`;
    return;
  }

  const icons: Record<StatusKey, string> = { in_progress: '⚡', done: '✅', blocked: '⚠️', todo: '📋', backlog: '📥' };
  const bgs: Record<StatusKey, string> = { in_progress: '#1a3a1a', done: '#1a1a40', blocked: '#3a2a00', todo: '#0a1a3a', backlog: '#1a1a2a' };

  view.innerHTML = recent.map((t, i) => {
    const a = aMap[t.assigneeAgentId || t.assignee_id || ''];
    const gem = a ? getGem(a.name) : null;
    const ns = normStatus(t.status) as StatusKey;
    return `
      <div class="activity-item" style="animation-delay:${i * 30}ms">
        <div class="ai-icon" style="background:${bgs[ns] || 'var(--card2)'}">${icons[ns] || '📌'}</div>
        <div class="ai-body">
          <div class="ai-title">${t.identifier ? `<span style="color:var(--muted);font-family:'JetBrains Mono',monospace;font-size:11px">${t.identifier}</span> ` : ''}${(t.title || 'Görev').substring(0, 60)}</div>
          <div class="ai-meta">
            ${gem ? `<span style="color:var(--gc,var(--text2))" class="${gem.cls}">${gem.name}</span> · ` : ''}
            ${t.company_name || ''} · <span style="color:var(--text2)">${statusLabel(t.status)}</span>
          </div>
        </div>
        <div class="ai-time">${ago(t.updatedAt || t.created_at)}</div>
      </div>`;
  }).join('');
}
